import { Icon, Input, InputRef } from '@billy/design-system'
import { ChangeEvent, forwardRef, ReactElement, Ref } from 'react'
import { useTranslation } from 'react-i18next'

import * as Styled from './styles'

interface OrganizationsSearchInputProps {
  value?: string
  isLoading?: boolean
  onChange?: (event: ChangeEvent<HTMLInputElement>) => void
  onClose?: () => void
}

export const OrganizationsSearchInput = forwardRef(
  (
    { isLoading, value, onChange, onClose }: OrganizationsSearchInputProps,
    forwardedRef: Ref<InputRef>,
  ): ReactElement => {
    const { t } = useTranslation()

    return (
      <Styled.SearchInputWrapper>
        <figure>
          <Icon icon="search" />
        </figure>

        <Input
          ref={forwardedRef}
          bordered={false}
          placeholder={`${t('search')}...`}
          value={value}
          onChange={onChange}
          spellCheck={false}
          suffix={
            isLoading && (
              <Styled.ArcIconWrapper>
                <Icon icon="circleDashed" />
              </Styled.ArcIconWrapper>
            )
          }
          size="sm"
        />

        <Styled.CloseIconWrapper>
          <Icon icon="x" onClick={onClose} />
        </Styled.CloseIconWrapper>
      </Styled.SearchInputWrapper>
    )
  },
)
